export default __webpack_public_path__ + "static/media/rocks-03.ea95e138.png";